import { render, staticRenderFns } from "./ExpertTermsRemindersHistory.vue?vue&type=template&id=0927f776&scoped=true"
import script from "./ExpertTermsRemindersHistory.vue?vue&type=script&lang=js"
export * from "./ExpertTermsRemindersHistory.vue?vue&type=script&lang=js"
import style0 from "./ExpertTermsRemindersHistory.vue?vue&type=style&index=0&id=0927f776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0927f776",
  null
  
)

export default component.exports